module.exports = {"Verify_Page":{"componentName":"VerifyPage"}}